import React, { Fragment } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemDropDown from "./controls/ListItemDropDown";
import ListItem from "./controls/ListItem";
import withRouter from "../../../components/withRouter";
import Grid from "../../layouts/Grid/Grid";
import Nx_Ctrl_Select from "../../controls/nx_ctrl_select";
import NxIconButton from "../../controls/nx_icon_button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { createBrowserHistory } from "history";

function Menu(props) {
  const history = createBrowserHistory();

  const handleActiveItem = (item) => {
    if (item.hasOwnProperty("url")) {
      if (item.url.includes("..")) {
        item.active =
          item.url.split("..")[1] === props.router.location.pathname;
      } else {
        const url = item.url.split("/")[1];
        item.active = props.router.location.pathname === `/${url}`;
      }
    } else {
      if (item.hasOwnProperty("children")) {
        item.children.forEach((child) => {
          if (child.hasOwnProperty("url")) {
            child.active =
              child.url.split(".")[1] === props.router.location.pathname;
            item.active = child.active === true;
          }
        });
        item.active = item.children.findIndex((child) => child.active) > -1;
        item.open = item.active;
      } else {
        item.active = false;
      }
    }
  };

  const removeTrailingSlash = (str) => {
    if (str.charAt(str.length - 1) === "/") {
      return str.slice(0, -1);
    }
    return str;
  };

  const navigate = (url) => {
    const split = url.split(":");
    let tempUrl = url;
    if (split.length > 1) {
      tempUrl = split[0];
    }
    tempUrl = removeTrailingSlash(tempUrl);
    props.router.navigate(`${tempUrl}`);
  };

  const renderMenuItems = () => {
    return (
      <Box sx={{ width: 200 }} role="presentation">
        <List>
          {props.items && props.items.length
            ? props.items.map((item, index) => {
                handleActiveItem(item);
                return (
                  <Fragment key={index}>
                    {item.children && item.children.length ? (
                      <ListItemDropDown
                        children={item.children}
                        active={item.active}
                        open={item.open}
                        icon={item.icon}
                        title={item.title}
                      />
                    ) : (
                      <ListItem
                        title={item.title}
                        active={item.active}
                        icon={item.icon}
                        onClick={
                          item.url ? () => navigate(item.url) : item.onClick
                        }
                      />
                    )}
                  </Fragment>
                );
              })
            : null}
        </List>
      </Box>
    );
  };

  const handleGoingBack = () => {
    history.go(-1);
  };
  return (
    <Grid
      style={{
        gridAutoFlow: "row",
        gridTemplateRows: "75px auto",
        overflow: "hidden",
      }}
    >
      <Grid
        style={{
          width: "100%",
          justifyContent: "start",
          alignItems: "center",
          gap: "20px",
          margin: "30px 0 0 55px",
          placeSelf: "center",
          gridAutoFlow: "column",
        }}
      >
        <NxIconButton onClick={handleGoingBack}>
          <ArrowBackIcon style={{ color: "#a5a7af" }} />
        </NxIconButton>
        <Nx_Ctrl_Select
          fieldConfig={{
            label: "Избери регион",
            multiple: false,
          }}
          className={"region_select"}
          data={props.regions}
          value={props.region_id}
          onChange={props.handleRegionChange}
        />
      </Grid>
      <Grid
        style={{
          justifyContent: "center",
          overflow: "hidden",
          overflowY: "auto",
          marginTop: "5px",
        }}
      >
        {renderMenuItems()}
      </Grid>
    </Grid>
  );
}

export default withRouter(Menu);
